import { MobileVacationOverview } from "@/mobile/pages/MobileVacationPage/MobileVacationOverview";
import { MobileVacationBooking } from "@/mobile/pages/MobileVacationPage/MobileVacationBooking";
import { M_MainFrame } from "@/mobile/components/M_MainFrame";

export function MobileVacationPage() {
    return <M_MainFrame>
        <MobileVacationOverview/>
        <MobileVacationBooking/>
    </M_MainFrame>;
}